<template>
    <table-ish>
        <table-ish-row-router-link
            v-for="property in properties"
            :key="property.uuid"
            :to="{
                name: $router.fix('dashboard.*.properties.show'),
                params: {
                    property: property.uuid
                }
            }"
        >
            <table-ish-cell>
                <truncate-hack>
                    {{ property.name }}
                </truncate-hack>

                <truncate-hack
                    v-if="property.address.street !== property.name"
                    slot="secondary"
                >
                    {{ property.address.street }}
                </truncate-hack>
            </table-ish-cell>
        </table-ish-row-router-link>
    </table-ish>
</template>

<script>
    export default {
        props: {
            properties: {
                type: Array,
                required: true
            }
        }
    }
</script>
